import { DeviceInfo } from '../types';

export const detectBrowser = (): string => {
  const userAgent = navigator.userAgent || 'unknown';
  return getBrowserInfo(userAgent);
};

// Enhanced browser detection with better support for alternative browsers
export const getBrowserInfo = (userAgent: string): string => {
  // For debugging/development
  if (import.meta.env.DEV) {
    console.log("Analyzing browser from UA:", userAgent);
  }
  
  // Normalize the user agent string to lowercase for case-insensitive matching
  const ua = userAgent.toLowerCase();
  
  // Check for headless browsers
  if (ua.includes('headlesschrome')) return 'Headless Chrome';
  
  // Check for alternative/privacy browsers - these should come first
  // Ecosia specifically matches both mobile and desktop variants
  if (ua.includes('ecosia')) return 'Ecosia';
  if (ua.includes('duckduckgo')) return 'DuckDuckGo';
  if (ua.includes('brave')) return 'Brave';
  if (ua.includes('yabrowser')) return 'Yandex Browser';
  if (ua.includes('ucbrowser')) return 'UC Browser';
  if (ua.includes('samsung')) return 'Samsung Browser';
  
  // More mainstream browsers - order matters
  if (ua.includes('firefox/')) return 'Firefox';
  if (ua.includes('edg/') || ua.includes('edge/')) return 'Edge';
  if (ua.includes('opr/') || ua.includes('opera/')) return 'Opera';
  // Chrome must be checked after Edge/Opera as they also include Chrome in UA
  if (ua.includes('chrome/') && !ua.includes('chromium')) return 'Chrome';
  if (ua.includes('chromium')) return 'Chromium';
  // Safari must come after Chrome as Chrome on iOS includes Safari
  if (ua.includes('safari/') && !ua.includes('chrome/')) return 'Safari';
  if (ua.includes('msie') || ua.includes('trident/')) return 'Internet Explorer';
  
  // Generic mobile browser detection as fallback
  if (ua.match(/android.*mobile/) && ua.includes('safari')) {
    return 'Android Browser';
  }
  
  // For debugging/development
  if (import.meta.env.DEV && !ua.includes('unknown')) {
    console.warn("Unrecognized browser UA:", userAgent);
  }
  
  return 'Other';
};
